import { Box, Panel } from '@hover/blueprint';
import React, { useEffect } from 'react';
import { animated, useSpring } from 'react-spring';

import { useTranslate } from 'src/shared/hooks';

import { animationConfig } from '../../../helpers/animationConfig';
import { BackgroundLogo } from '../../BackgroundLogo';
import { FastLoader } from '../../FastLoader';

import { AnimatedHeader } from './AnimatedHeader';
import { AnimatedText } from './AnimatedText';

const AnimatedBody = ({ finishLoading }: { finishLoading: () => void }) => {
  useEffect(() => {
    // timeout is calculated by adding up the duration of each step
    const timer = setTimeout(finishLoading, 4950);

    return () => clearTimeout(timer);
  }, [finishLoading]);

  const loaderContainerStyle = useSpring(animationConfig.loaderAnimation);
  const t = useTranslate('designStudio');

  return (
    <Panel
      alignItems="center"
      backgroundColor="primaryBase"
      borderRadius="0"
      height="100vh"
      justifyContent="center"
      overflow="hidden"
      position="absolute"
      top="0"
      width="100vw"
    >
      <BackgroundLogo />
      <animated.div style={loaderContainerStyle}>
        <FastLoader color="neutral.0" />
      </animated.div>
      <Box justifyContent="center" width="100%">
        <AnimatedText
          animationStep={1}
          color="neutral000"
          key="experiment"
          size={400}
        >
          {t('loading.experimentWithColors')}
        </AnimatedText>
        <AnimatedText
          animationStep={2}
          color="neutral000"
          key="material"
          size={400}
        >
          {t('loading.tryNewMaterials')}
        </AnimatedText>
        <AnimatedText
          animationStep={3}
          color="neutral000"
          key="share"
          size={400}
        >
          {t('loading.shareYourDesign')}
        </AnimatedText>
        <AnimatedHeader
          animationStep={4}
          color="neutral000"
          key="creative"
          size={600}
        >
          {t('loading.letsGetCreative')}
        </AnimatedHeader>
      </Box>
    </Panel>
  );
};

export function LoadingPage({ finishLoading }: { finishLoading: () => void }) {
  return <AnimatedBody finishLoading={finishLoading} />;
}
